<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-08-19 03:06:32
 * @LastEditors: Please set LastEditors
 -->
<template>
    <el-dialog
            title="选择导入文件"
            :visible="true"
            width="30%"
            :before-close="handleClose">
        <el-form ref="form" :model="form" label-width="120px"  class="mt20">
            <el-form-item label="类型:">
                <el-radio v-model="form.to_type" :label="2">经销商</el-radio>
                <el-radio v-model="form.to_type" :label="3">门店</el-radio>
            </el-form-item>
            <el-form-item label="选择导入文件:">
                <el-upload
                        ref="upload"
                        class="upload-demo"
                        :action="url"
                        :on-success="successUpload"
                        :on-error="error"
                        accept=".xlsx"
                        name="outwarehouse_file"
                        :file-list="fileArray"
                        :data="form"
                        :headers="headers"
                        :on-change="handleChange"
                        :auto-upload="false"
                >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传.xlsx文件</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="模板下载:">
                <a style="cursor: pointer;color:red" @click="downloadTem()">下载模板</a>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="sub()">确 定</el-button>
  </span>
            <importDetail  v-if='detail' :table='table' v-on:handleClose='detail=false' @refresh='refresh'/>

    </el-dialog>
</template>

<script>
import { setTimeout } from 'timers';
import importDetail from './importDetail.vue'
    export default {
        name: "importData",
        data(){
            return {
                detail:false,
                form: {
                    to_type:2
                },
                fileArray: [],
                url:'https://logistics.c.'+process.env.VUE_APP_URL + '/outwarehouses.import',
                headers: {
                    // 'Content-Type': 'multipart/form-data'  //之前说的以表单传数据的格式来传递fromdata
                },
                table:{}
            }
        },
        
      components:{
        importDetail
    },
    created(){
        this.init()
    },
        methods:{
                init(){
                         if(process.env.NODE_ENV == 'development'){
                        this.url = 'https://logistics.c.'+process.env.VUE_APP_URL + '/outwarehouses.import';
                    }else if(process.env.NODE_ENV == 'production'){
                        this.url = 'https://logistics.'+process.env.VUE_APP_URL + '/outwarehouses.import';
                    }else{
                        this.url = 'https://logistics.c.'+process.env.VUE_APP_URL + '/outwarehouses.import';
                    }
                },
                handleChange(value,valueList){
        
            if(valueList.length>1){
                valueList.splice(0,1)
            }
            this.fileArray=valueList
            this.file=value
            },
            successUpload(response, file, fileList){
                // this.$message({
                //     message: message,
                //     type: 'success'
                // });
                if(response.data.total_failure==0){
                this.$message({
                    type:'success',
                    message:'导入成功'
                })
                this.$emit('handleClose');
                  this.$emit('refresh');
            }else{
                this.table=response.data
             this.detail=true
        
            }

            },
                error(error){
                  this.$message({
                    type:'error',
                    message:'上传失败'
                })
                },
            //模板下载
            downloadTem(){
                let access_tokens = localStorage.getItem('access_tokens');
                   this.headers.Authorization ='Bearer' + " " +localStorage.getItem('access_tokens');
                   var that=this
                     setTimeout(()=>{
                           window.open(this.$Base_Export
                    + '/outwarehouses.template?is_export=1&signature=' + that.$md5(access_tokens)+'&type='+that.form.to_type)
                     },100)
            },
            refresh(){
                 this.$emit('handleClose');
                this.$emit('refresh');
            },
            sub(){
                var that =this
                   this.headers.Authorization ='Bearer' + " " +localStorage.getItem('access_tokens');
                    console.log(this.fileArray)
                 that.$refs.upload.submit();

                setTimeout(()=>{

                },200)
          
               
            },
        handleClose(){
            this.$emit('handleClose');
        }
    }
    }
</script>

<style scoped>

</style>